export default __webpack_public_path__ + "maps-examples-animate-image-layer-960-0c7cdcfcec2e925a557c5f50d47c5025.webp";